import { CarriageWayEnum } from '../types';

const createRequestJSON = (
  portfolioId,
  familyConfig,
  roadLayoutConfig,
  roadwayConfig,
  lightingClassConfig,
  luminaireLayoutConfig,
  optimizationConfig
) => {
  const JSONTemplate = {
    service_type: 'find_street_config',
    common: {
      user: 'demo@relux.com',
      manufacturer: 'demo',
    },
    request: {
      root_url: 'https://fsc1-signify.relux.com',
      family_id: '1',
      api_version: 3,
      embed_fsc_version: 1,
      embed_article: 1,
      params: {
        filter: {
          var_number_wild: '*',
          highest_flux_only: true,
          light_color_wild: '4000*',
          color: [],
          flux: [],
          optic: [],
        },
        optimizer_settings: {
          ignore_rei: false,
          ignore_ti: false,
          optimize_style: 1,
          number_of_results: 5,
          use_lampsets: true,
        },
        scene: {
          name: 'sd-refroad-01',
          surface: {
            name: 'sd-main',
            type: 'SingleCarriageway',
            width: 7,
            central_reservation: 0,
            n_lanes: 2,
            r_table: 'R3',
            q0: 0.07,
            class: 'M3',
            surfaces: [],
          },
          lum_row: {
            mfactor: 0.85,
            style: 'Right',
            overhang: {
              start: 0,
              n_steps: 2,
              increment: 0.5,
            },
            delta: {
              start: 20,
              n_steps: 21,
              increment: 1,
            },
            tilt: {
              start: 0,
              n_steps: 6,
              increment: 1,
            },
            lph: {
              start: 8,
              n_steps: 5,
              increment: 0.5,
            },
          },
        },
      },
    },
  };
  let data = Object.assign({}, JSONTemplate);
  // Check if custom classes are provided
  const isCustomLightningClassProvided =
    lightingClassConfig?.customClasses?.mainCustomClass ||
    lightingClassConfig?.customClasses?.borderAreaRightCustomClass ||
    lightingClassConfig?.customClasses?.borderAreaLeftCustomClass;

  data.request.params.scene.surface.type = roadLayoutConfig.carriageWay;
  data.request.params.scene.surface.width = roadwayConfig.roadWidth;
  if (roadLayoutConfig.carriageWay === CarriageWayEnum.DOUBLE) {
    data.request.params.scene.surface.central_reservation =
      roadwayConfig.widthOfCentralReservation;
  }
  data.request.params.scene.surface.n_lanes = roadwayConfig.numberOfLanes;
  data.request.params.scene.surface.r_table = roadwayConfig.covering;
  data.request.params.scene.surface.q0 = roadwayConfig.q0;
  data.request.params.scene.surface.road_length = roadwayConfig.roadLength;
  data.request.params.scene.surface.class = lightingClassConfig.roadClasses;
  // If custom classes are provided, then use them instead of the default classes
  console.log(
    'lightingClassConfig.customClasses anis 0000',
    lightingClassConfig.customClasses
  );

  if (isCustomLightningClassProvided) {
    data.request.params.scene.surface.custom_class =
      lightingClassConfig.customClasses.mainCustomClass;
    // biome-ignore lint/performance/noDelete: <explanation>
    delete data.request.params.scene.surface.class;
  }
  let out = [];
  if (roadLayoutConfig.borderAreaRight) {
    out.push({
      name: 'sd-fpath-right',
      type: 'FootPath',
      style: 'Right',
      kerb_distance: roadwayConfig.borderAreaRightKerbDistance,
      width: roadwayConfig.borderAreaRightWidth,
      class: lightingClassConfig.borderAreaRightClasses ?? null,
      custom_class:
        lightingClassConfig?.customClasses?.rightBorderCustomClass ?? null,
    });
  }
  if (roadLayoutConfig.borderAreaLeft) {
    out.push({
      name: 'sd-fpath-left',
      type: 'FootPath',
      style: 'Left',
      kerb_distance: roadwayConfig.borderAreaLeftKerbDistance,
      width: roadwayConfig.borderAreaLeftWidth,
      class: lightingClassConfig.borderAreaLeftClasses ?? null,
      custom_class:
        lightingClassConfig?.customClasses?.leftBorderCustomClass ?? null,
    });
  }
  // If custom classes are provided, then use them instead of the default classes

  for (const element of out) {
    // biome-ignore lint/performance/noDelete: <explanation>
    if (element.custom_class) delete element.class;
    if (element.class) delete element.custom_class;
  }

  data.request.params.scene.surface.surfaces = out;
  data.request.params.scene.surface.calc_ti = true;

  data.request.params.scene.lum_row.mfactor =
    optimizationConfig.maintenanceFactor;
  data.request.params.scene.lum_row.style =
    luminaireLayoutConfig.luminaireConfig;

  if (optimizationConfig.shouldOptimizeDistanceBetweenPoles) {
    data.request.params.scene.lum_row.delta.start =
      optimizationConfig.distanceBetweenPoles.rangeValue.min;
    data.request.params.scene.lum_row.delta.n_steps =
      1 +
      Math.floor(
        (optimizationConfig.distanceBetweenPoles.rangeValue.max -
          optimizationConfig.distanceBetweenPoles.rangeValue.min) /
          optimizationConfig.distanceBetweenPoles.rangeValue.step
      );
    data.request.params.scene.lum_row.delta.increment =
      optimizationConfig.distanceBetweenPoles.rangeValue.step;
  } else {
    data.request.params.scene.lum_row.delta =
      optimizationConfig.distanceBetweenPoles.value;
  }

  if (optimizationConfig.shouldOptimizeOverhang) {
    data.request.params.scene.lum_row.overhang.start =
      optimizationConfig.overhang.rangeValue.min;
    data.request.params.scene.lum_row.overhang.n_steps =
      1 +
      Math.floor(
        (optimizationConfig.overhang.rangeValue.max -
          optimizationConfig.overhang.rangeValue.min) /
          optimizationConfig.overhang.rangeValue.step
      );
    data.request.params.scene.lum_row.overhang.increment =
      optimizationConfig.overhang.rangeValue.step;
  } else {
    data.request.params.scene.lum_row.overhang =
      optimizationConfig.overhang.value;
  }

  if (optimizationConfig.shouldOptimizeHeightOfTheLightPoint) {
    data.request.params.scene.lum_row.lph.start =
      optimizationConfig.heightOfTheLightPoint.rangeValue.min;
    data.request.params.scene.lum_row.lph.n_steps =
      1 +
      Math.floor(
        (optimizationConfig.heightOfTheLightPoint.rangeValue.max -
          optimizationConfig.heightOfTheLightPoint.rangeValue.min) /
          optimizationConfig.heightOfTheLightPoint.rangeValue.step
      );
    data.request.params.scene.lum_row.lph.increment =
      optimizationConfig.heightOfTheLightPoint.rangeValue.step;
  } else {
    data.request.params.scene.lum_row.lph =
      optimizationConfig.heightOfTheLightPoint.value;
  }

  if (optimizationConfig.shouldOptimizeTiltOfTheLuminaire) {
    data.request.params.scene.lum_row.tilt.start =
      optimizationConfig.tiltOfTheLuminaire.rangeValue.min;
    data.request.params.scene.lum_row.tilt.n_steps =
      1 +
      Math.floor(
        (optimizationConfig.tiltOfTheLuminaire.rangeValue.max -
          optimizationConfig.tiltOfTheLuminaire.rangeValue.min) /
          optimizationConfig.tiltOfTheLuminaire.rangeValue.step
      );
    data.request.params.scene.lum_row.tilt.increment =
      optimizationConfig.tiltOfTheLuminaire.rangeValue.step;
  } else {
    data.request.params.scene.lum_row.tilt =
      optimizationConfig.tiltOfTheLuminaire.value;
  }

  data.request.params.optimizer_settings.ignore_rei =
    optimizationConfig.ignoreRei;
  data.request.params.optimizer_settings.ignore_ti =
    optimizationConfig.ignoreTi;

  if (optimizationConfig.optimizationType === 'maximum_distance') {
    data.request.params.optimizer_settings.optimize_style = 1;
  } else {
    data.request.params.optimizer_settings.optimize_style = 2;
  }
  data.request.family_id = familyConfig.familyIds;
  data.request.portfolioId = portfolioId;
  return data;
};

export default createRequestJSON;
